import { useState, ReactElement } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { CloseRounded } from "@remo-co/ui-core/src/icons/CloseRounded";
import { useI18n } from "i18n";
import { RatingType } from "modules/guestExperienceSurvey/constants";
import classNames from "classnames";
import { useStyles } from "./styles";
import Rating from "../Rating/Rating";

interface Props {
  className?: string;
  onClose: () => void;
  onSubmit: (rating: RatingType) => void;
}

const Survey = ({ className = "", onClose, onSubmit }: Props): ReactElement => {
  const [submitted, setSubmitted] = useState(false);
  const { t } = useI18n(["auth", "common", "event"]);
  const classes = useStyles();

  return (
    <Card
      className={classNames(classes.surveyCard, className)}
      size="xs"
      data-testid="survey-card"
    >
      <CloseRounded
        data-testid="close-survey"
        className={classes.closeIcon}
        onClick={onClose}
      />
      {submitted ? (
        <>
          <Typography variant="h5">{t("event:guest.survey.thanks")}</Typography>
          <Button
            color="dark"
            size="md"
            variant="secondary"
            className={classes.closeButton}
            onClick={onClose}
          >
            {t("common:button.close")}
          </Button>
        </>
      ) : (
        <>
          <Typography variant="h5">{t("event:guest.survey.title")}</Typography>

          <Rating
            onSelect={(rating: RatingType) => {
              setSubmitted(true);
              onSubmit(rating);
            }}
          />
        </>
      )}
    </Card>
  );
};

export default Survey;
